import actions from '@/Core.Service.Domain/MessageCenter/Management/Store/actions.js';
import getters from '@/Core.Service.Domain/MessageCenter/Management/Store/getters.js';
import mutations from '@/Core.Service.Domain/MessageCenter/Management/Store/mutations.js';

const state = {
  usersList: [],
  messagesList: [],
  messageToEdit: {},
  messagesTypesList: [],
  isEditMessageDirty: false,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
